import { createFileRoute } from '@tanstack/react-router';

import { AdminStaffView } from 'src/sections/admin/staff/admin-staff-view';

export const Route = createFileRoute('/admin-skidog/staff')({
  component: AdminStaffPage,
});

function AdminStaffPage() {
  return <AdminStaffView />;
}
